import { Box, BoxProps, ColumnLayout } from "@amzn/awsui-components-react";
import * as React from "react";
import { USDollar } from "../../../util";
import { Funding } from "../../../calcBusterTypes";

const MetricBox = (
  label: string,
  value: number,
  color: BoxProps.Color = "inherit"
) => (
  <Box padding="l" textAlign="center" color={color} variant="awsui-key-label">
    <Box
      variant="h2"
      color={color}
      textAlign="center"
      margin={{ bottom: "xs" }}
    >
      {USDollar.format(value)}
    </Box>
    <Box variant="awsui-key-label" color={color} textAlign="center">
      {label}
    </Box>
  </Box>
);

const AnnualRunRateMetrics: React.FC<{ funding: Funding }> = ({ funding }) => {
  const metrics = React.useMemo(
    () => [
      {
        label: "Total Annual Run Rate",
        value: funding.annualRunRate,
        color: "text-status-secondary",
      },
      {
        label: "MAP Eligible ARR",
        value: funding.map?.mobilizeAndMigrate?.eligibleAnnualRunRate ?? 0,
        color: "text-status-info",
      },
      {
        label: "SAP/Oracle Eligible ARR",
        value:
          funding.map?.mobilizeAndMigrate?.credits?.sapAndOracle
            ?.eligibleAnnualRunRate ?? 0,
        color: "text-status-error",
      },
      {
        label: "DB & Analytics Eligible ARR",
        value:
          funding.map?.mobilizeAndMigrate?.credits?.dbAndAnalytics
            ?.eligibleAnnualRunRate ?? 0,
        color: "text-status-warning",
      },
    ],
    [funding]
  );

  return (
    <Box textAlign={"center"} padding="l">
      <ColumnLayout columns={2} variant="text-grid">
        {metrics.map((metric) =>
          MetricBox(metric.label, metric.value, metric.color as BoxProps.Color)
        )}
      </ColumnLayout>
    </Box>
  );
};

export default AnnualRunRateMetrics;
